import React,{useState} from 'react';
// styles
import useStyles from './styles';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
//import { Typography } from '@material-ui/core';
import { Typography } from '../../components/Wrappers';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ViewRows from '../ViewRows';


export default function ControlledAccordions({
	data,
	module,
	recordId,
	initialValues,
	errors,
	headerBackground = false,
	onChange,
	view = 'editview',
	getDataLine,
	isExpanded=true,
	setEmailModal,
	quickCreate=false,
	hiddenAll
}) {
	console.log("hiddenAll child",hiddenAll)
	const classes = useStyles();
	const [ expanded, setExpanded ] = useState(isExpanded);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};
	return (
		<div className={classes.root}>
			{data.map((panel, panelKey) => (
				<>
				<Accordion
					className={classes.accordionBox}
					onChange={handleChange(panelKey)}
					key={panelKey}
					defaultExpanded={expanded}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls={'panel' + panelKey + 'bh-content'}
						id={'panel' + panelKey + 'bh-content'}
						className={headerBackground ? classes.headerBackground : null}
					>
						<Typography className={classes.text} weight="light" variant="subtitle2">
							{panel.label.toUpperCase()}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ViewRows
							data={panel}
							initialValues={initialValues}
							errors={errors}
							module={module}
							onChange={onChange}
							view={view}
							setEmailModal={setEmailModal}
							recordId={recordId}
							quickCreate={quickCreate}
							hiddenAll={hiddenAll}
						/>
					</AccordionDetails>
				</Accordion>
				{panel?.panels?.length > 0 ? panel.panels.map((item)=>
				(<Accordion
					className={classes.accordionBox}
					onChange={handleChange(panelKey)}
					key={panelKey}
					defaultExpanded={expanded}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls={'panel' + item?.panelKey + 'bh-content'}
						id={'panel' + item?.panelKey + 'bh-content'}
						className={headerBackground ? classes.headerBackground : null}
					>
						<Typography className={classes.text} weight="light" variant="subtitle2">
							{item?.label.toUpperCase()}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ViewRows
							data={item}
							initialValues={initialValues}
							errors={errors}
							module={module}
							onChange={onChange}
							view={view}
							setEmailModal={setEmailModal}
							recordId={recordId}
							quickCreate={quickCreate}
							hiddenAll={hiddenAll}
							// getDataLine={getDataLine}
						/>
					</AccordionDetails>
				</Accordion>))
				 : ""}
				</>
			))}
		</div>
	);
}
